import type { Component } from 'vue'
import { defineAsyncComponent } from 'vue'

const asyncComponentsCache: Record<string, ReturnType<typeof defineAsyncComponent>> = {}

function transformPathToComponentName(filePath: string) {
  let cleanPath = filePath.split('componentsGlobal/')[1]

  if (!cleanPath) {
    return null
  }

  cleanPath = cleanPath.replace(/\.[^/.]+$/, '')

  return cleanPath
    .toLowerCase()
    .replace(/\//g, '')
    // delete duplicates that are next to each other
    .replace(/(.{3,}?)\1+/g, '$1')
}

const GLOBAL_COMPONENTS_MAP = Object.entries(import.meta.glob('../../ui/componentsGlobal/**/*.vue'))
  .reduce((
    acc: Record<string, () => Promise<Component>>,
    [key, value],
  ) => {
    const componentName = transformPathToComponentName(key)

    if (!componentName) {
      return acc
    }

    acc[componentName] = value as () => Promise<Component>
    return acc
  }, {})

export function getGlobalComponent(name: string) {
  const key = name.toLowerCase()

  if (!GLOBAL_COMPONENTS_MAP[key]) {
    return null
  }

  if (asyncComponentsCache[key]) {
    return asyncComponentsCache[key]
  }

  asyncComponentsCache[key] = defineAsyncComponent(() => GLOBAL_COMPONENTS_MAP[key]())
  return asyncComponentsCache[key]
}
